export const getters = {
  getMessage: (state) => state.message,
};
